import { linkTools } from '@joint/plus';
import { buttonBodyAttributes, buttonIconAttributes } from '../theme';
export default class InsertNodeTool extends linkTools.Button {
    preinitialize(options) {
        this.name = 'insert-node-tool';
        this.attributes = {
            cursor: 'pointer',
        };
        /** Note: it mimics the SystemButton plus icon */
        this.children = [{
                tagName: 'circle',
                className: 'add-button-body',
                attributes: Object.assign({}, buttonBodyAttributes)
            }, {
                tagName: 'path',
                className: 'add-button-icon',
                attributes: Object.assign({}, buttonIconAttributes)
            }];
        this.options = Object.assign({ distance: '50%' }, options);
    }
    initialize() {
        super.initialize();
        this.el.classList.add('fade-in');
    }
}
